import React, { useEffect } from 'react'

import { TopNav } from '../TopNav'
import { ScrollTop } from '../TopNav/ScrollTop'
import { Footer } from '@shared/Footer'
import { GsapTriggers } from './GsapTriggers'
import { GlobalStyles } from '@utils/GlobalStyles'
import { useMinimalLayout } from './useMinimalLayout'

export const SharedLayout = ({
  children,
  appIcons,
  showBundleLink = true,
  bg = 'inherit',
  minimalLayout = false,
  ...props
}) => {
  useEffect(() => {
    // Update the --msk-bg variable in css
    const root = document.documentElement
    root.style.setProperty('--msk-bg', bg)
  }, [bg])

  // Check if minimal layout is triggered by querystring
  const qsMl = useMinimalLayout()

  // Use passed in minimalLayout prop, fall back to qs
  const ml = minimalLayout || qsMl

  return (
    <>
      <GlobalStyles />
      <GsapTriggers />

      {!ml ? <TopNav imageData={appIcons} {...props} /> : null}

      {children}

      {!ml ? <Footer /> : null}

      {!ml ? (
        <ScrollTop appIcons={appIcons} showBundleLink={showBundleLink} />
      ) : null}
    </>
  )
}
